<template>
  <div class="big-screen-container">
    <!-- 底图容器 - 用户可自行填充内容 -->
    <div class="background-layer" id="domId">
      <!-- 用户自定义底图内容区域 -->

    </div>

    <!-- 内容层 - 叠加在底图之上 -->
    <div class="content-layer">
      <!-- 顶部标题栏 -->
      <header class="header">
        <!-- 科技感遮罩层 -->
        <div class="header-mask"></div>
        <!-- 网格背景 -->
        <div class="grid-bg"></div>
        <!-- 发光边框 -->
        <div class="glow-border"></div>
        <!-- 左右角对称短斜科技线条 -->
        <div class="header-corner-line tl"></div>
        <div class="header-corner-line tr"></div>
        <div class="header-corner-line bl"></div>
        <div class="header-corner-line br"></div>
        <!-- 中间标题上下短渐变横线 -->
        <div class="header-title-line top"></div>
        <div class="header-title-line bottom"></div>
        <!-- 底部渐变发光分割线 -->
        <div class="header-bottom-line"></div>

        <div class="header-left">
          <div class="logo-section">
            <img class="logo-icon" src="./png/Logo.png" alt="Logo" style="height: 80px; width: 50px;" />
            <div class="logo-text">
              <img src="./png/LogoName.png" alt="Logo Name" style="width: 200px; height: 50px;" />
            </div>
            <!-- 粒子光效 -->
            <div class="logo-particle p1"></div>
            <div class="logo-particle p2"></div>
            <div class="logo-particle p3"></div>
            <div class="logo-particle p4"></div>
          </div>
        </div>

        <div class="header-center">
          <h1 class="main-title" data-text="达川区 X173 陈家乡至渠县界公路(龙会乡至渠县界段)">{{ mainTitle }}</h1>
        </div>

        <div class="header-right">
          <div class="time-section">
            <span class="time-icon">🕐</span>
            <span class="time-value">{{ currentTime }}</span>
          </div>
          <div class="company-info">
            <span class="company-name">中国华西企业股份有限公司Bim中心制</span>
          </div>
          <div class="header-icons">
            <span class="icon-item">📡</span>
            <span class="icon-item">🔒</span>
          </div>
        </div>
      </header>

    </div>

    <!-- 左侧面板 -->
    <aside class="left-panel" style="margin-top: 30px;margin-left: -15px;">
      <div class="panel-card" :style="{ width: '500px', height: '250px' }">
        <div class="card-header">
          <span class="card-icon">📊</span>
          <span class="card-title">工程概况</span>
          <div class="card-decoration"></div>
        </div>
        <div class="card-content project-overview">
          <div class="particles"></div>
          <!-- 左侧统计数据 -->
          <div class="stats-column">
  <div class="stat-item">
    <span class="stat-label">施工内容及规模</span>
    <span class="stat-value">{{ projectStats.constructionContent }}</span>
  </div>
  <div class="stat-item">
    <span class="stat-label">施工概算额（万元）</span>
    <span class="stat-value">{{ projectStats.budgetAmount }}</span>
  </div>
  <div class="stat-item">
    <span class="stat-label">计划工期（天）</span>
    <span class="stat-value">{{ projectStats.plannedDuration }}</span>
  </div>
</div>


        </div>
      </div>

      <div class="panel-card" :style="{ width: '500px', height: '400px' }">
        <div class="card-header">
          <span class="card-icon">🛠️</span>
          <span class="card-title">{{ qualityData.title }}</span>
          <div class="card-decoration"></div>
        </div>
        <div class="card-content">
          <div class="particles"></div>
          <!-- 顶部统计横条 -->
          <div class="stats-bar">
            <div class="stat-item">
              <div class="stat-icon">🔧</div>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ qualityData.stats.total }}</span>
              <span class="stat-label">问题总数</span>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ qualityData.stats.serious }}</span>
              <span class="stat-label">严重问题</span>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ qualityData.stats.rectified }}</span>
              <span class="stat-label">已整改</span>
            </div>
            <div class="stat-item highlight">
              <span class="stat-num">{{ qualityData.stats.rectificationRate }}</span>
              <span class="stat-label">整改率</span>
            </div>
          </div>
          <div id="quality-chart" style="width: 100%; height: 210px;"></div>
        </div>
      </div>
      <div class="panel-card" :style="{ width: '500px', height: '450px' }">
        <div class="card-header">
          <span class="card-icon">⚠️</span>
          <span class="card-title">安全隐患情况</span>
          <div class="card-decoration"></div>
        </div>
        <div class="card-content">
          <div class="particles"></div>
          <!-- 顶部统计横条 -->
          <div class="stats-bar">
            <div class="stat-item">
              <div class="stat-icon">⚠️</div>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ safetyData.stats.total }}</span>
              <span class="stat-label">隐患总数</span>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ safetyData.stats.highRisk }}</span>
              <span class="stat-label">重大隐患</span>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ safetyData.stats.mediumRisk }}</span>
              <span class="stat-label">已处理</span>
            </div>
            <div class="stat-item highlight">
              <span class="stat-num">{{ safetyData.stats.rectificationRate }}</span>
              <span class="stat-label">处理率</span>
            </div>
          </div>
          <div id="safety-chart" style="width: 100%; height: 240px;"></div>
        </div>
      </div>

    </aside>

    <!-- 右侧面板 -->
    <aside class="right-panel" style="margin-top: 30px;margin-right: -25px;">
      <div class="panel-card" :style="{ width: '500px', height: '550px' }">
        <div class="card-header">
          <span class="card-icon">🗺️</span>
          <span class="card-title">项目影像资料</span>
          <div class="card-decoration"></div>
        </div>
        <div class="card-content">
          <div class="particles"></div>
          <div class="file-list">
            <div class="list-header">
              <span class="list-col name-col">名称</span>
              <span class="list-col format-col">格式</span>
              <span class="list-col section-col">路段</span>
            </div>
            <div v-for="(section, sectionIndex) in markerLocations" :key="sectionIndex">
              <div v-for="(file, fileIndex) in section.fileList" :key="sectionIndex + '-' + fileIndex" class="list-item"
                @dblclick="openFileDialog(file)">
                <span class="list-col name-col">{{ file.name }}</span>
                <span class="list-col format-col">{{ file.format }}</span>
                <span class="list-col section-col">{{ section.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 文件详情弹窗 -->
     
      <!-- 路段资料弹窗 -->

      <div v-if="showSectionDialog" class="dialog-mask" @click="closeSectionDialog"></div>

      <div class="panel-card" :style="{ width: '500px', height: '300px' }">
        <div class="card-header">
          <span class="card-icon">📦</span>
          <span class="card-title">物料信息情况</span>
          <div class="card-decoration"></div>
        </div>
        <div class="card-content material-panel">
          <div class="particles"></div>
          <!-- 顶部统计字段 -->
          <div class="material-stats">
  <div class="material-stat">
    <span class="stat-value">{{ projectStats.totalMaterialIn进场 }}</span>
    <span class="stat-label">累计材料进场</span>
  </div>
  <div class="material-stat">
    <span class="stat-value">{{ projectStats.todayMaterialIn进场 }}</span>
    <span class="stat-label">今日材料进场</span>
  </div>
</div>

          <!-- 环形进度条区域 -->
          <div class="progress-rings">
            <div class="ring-item">
              <div class="ring-container">
                <svg class="ring-svg" viewBox="0 0 80 80">
                  <circle class="ring-bg" cx="40" cy="40" r="35" fill="none" stroke="rgba(0,200,180,0.2)"
                    stroke-width="6" />
                  <circle class="ring-progress orange" cx="40" cy="40" r="35" fill="none" stroke="#f39c12"
                    stroke-width="6" stroke-linecap="round" stroke-dasharray="219.91 219.91" stroke-dashoffset="12.3"
                    transform="rotate(-90 40 40)" />
                </svg>
                <span class="ring-value">94.44%</span>
              </div>
              <span class="ring-label">泵送混凝土占比</span>
            </div>
            <div class="ring-item">
              <div class="ring-container">
                <svg class="ring-svg" viewBox="0 0 80 80">
                  <circle class="ring-bg" cx="40" cy="40" r="35" fill="none" stroke="rgba(0,200,180,0.2)"
                    stroke-width="6" />
                  <circle class="ring-progress green" cx="40" cy="40" r="35" fill="none" stroke="#00c8b4"
                    stroke-width="6" stroke-linecap="round" stroke-dasharray="219.91 219.91" stroke-dashoffset="207.6"
                    transform="rotate(-90 40 40)" />
                </svg>
                <span class="ring-value">5.56%</span>
              </div>
              <span class="ring-label">自拌占比</span>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-card" :style="{ width: '500px', height: '250px' }">
        <div class="card-header">
          <span class="card-icon">👷</span>
          <span class="card-title">施工人员情况</span>
          <div class="card-decoration"></div>
        </div>
<!-- 示例：工程进度数据 -->
<div class="card-content staff-panel">
  <div class="particles"></div>
  <div class="staff-column">
    <span class="staff-num">{{ constructionData.earthwork }}</span>
    <span class="staff-label">土方工程</span>
    <div class="staff-icon blue">🚜</div>
  </div>
  <div class="staff-column">
    <span class="staff-num">{{ constructionData.labor }}</span>
    <span class="staff-label">劳务</span>
    <div class="staff-icon green">👷</div>
  </div>
  <div class="staff-column">
    <span class="staff-num">{{ constructionData.latticeBeam }}</span>
    <span class="staff-label">格构梁</span>
    <div class="staff-icon orange">🔧</div>
  </div>
</div>

      </div>

    </aside>

    <!-- 底部面板 -->
    <aside class="bottom-panel" style="margin-bottom: 0px;">
      <div class="panel-card" :style="{ width: '1300px', height: '440px' }">
        <div class="card-header">
          <span class="card-icon">📍</span>
          <span class="card-title">工程进度</span>
          <div class="card-decoration"></div>
        </div>
        <div class="card-content progress-panel">
          <div class="particles"></div>
          <!-- 图例 -->
          <div class="legend">
            <div class="legend-item">
              <span class="bubble green"></span>
              <span>已完成</span>
            </div>
            <div class="legend-item">
              <span class="bubble yellow"></span>
              <span>进行中</span>
            </div>
            <div class="legend-item">
              <span class="bubble red"></span>
              <span>未开始</span>
            </div>
            <!-- 进度分色图按钮 -->
            <div class="progress-btn-container">
              <button class="progress-btn" @click="overrideColor">进度分色图</button>
            </div>
          </div>



          <!-- 表头 -->
          <div class="progress-header">
            <span class="col-title">施工段</span>
            <span class="col-title">路基土石方</span>
            <span class="col-title">路基支档</span>
            <span class="col-title">路基桥涵</span>
            <span class="col-title">路基排水</span>
            <span class="col-title">桥梁</span>
            <span class="col-title">交安及其他</span>
          </div>

          <!-- 数据行 - 动态绑定markerLocations -->
          <div class="progress-row" v-for="item in markerLocations" :key="item.id">
            <span class="row-label">{{ item.name }}</span>
            <span class="bubble-cell"><span :class="['bubble', item.subgradeEarthwork]"></span></span>
            <span class="bubble-cell"><span :class="['bubble', item.subgradeSupport]"></span></span>
            <span class="bubble-cell"><span :class="['bubble', item.subgradeBridge]"></span></span>
            <span class="bubble-cell"><span :class="['bubble', item.subgradeDrainage]"></span></span>
            <span class="bubble-cell"><span :class="['bubble', item.bridge]"></span></span>
            <span class="bubble-cell"><span :class="['bubble', item.trafficSafety]"></span></span>
          </div>


        </div>
      </div>

    </aside>
    <div v-if="showSectionDialog" class="section-dialog">
      <div class="dialog-header">
        <span class="dialog-title">{{ selectedSection?.name }}</span>
        <button class="dialog-close" @click="closeSectionDialog">×</button>
      </div>
      <div class="dialog-content">
        <!-- 直接显示第一张图片 -->
        <div class="image-preview-simple" v-if="selectedSection?.fileList?.length > 0">
          <img :src="selectedSection.fileList[0].path" :alt="selectedSection.fileList[0].name" class="preview-image" />
        </div>
        <div v-else class="no-image">
          <span>暂无图片</span>
        </div>
      </div>
    </div>
    <div v-if="showDialog" class="file-dialog" @mousedown="startDrag" @mousemove="onDrag" @mouseup="stopDrag">
        <div class="dialog-header">
          <span class="dialog-title">{{ selectedFile?.name }}</span>
          <button class="dialog-close" @click="closeDialog">×</button>
        </div>
        <div class="dialog-content">
          <!-- 直接显示图片 -->
          <div class="image-preview-dialog" v-if="selectedFile?.path">
            <img :src="selectedFile.path" :alt="selectedFile.name" class="preview-image-dialog" />
          </div>
          <div v-else class="no-image-dialog">
            <span>暂无图片</span>
          </div>
        </div>
        <div class="dialog-resize-handle"></div>
      </div>
      <div v-if="showDialog" class="dialog-mask" @click="closeDialog"></div>

    </div><!-- 闭合 content-layer -->


</template>

<script>
import * as echarts from 'echarts';
import { getDataByDomain } from './data/index';
let app;
let viewer3D;
let model3D;
export default {
  name: 'BigScreen',
  props: {
    suffix: {
      type: String,
      default: '173'
    }
  },
  data() {
    const domainData = getDataByDomain(this.suffix)
    return {
     //天地图相关
     viewer: null,
      app: null,
      uiMng: null,
      mainToolbar: null,
      layerMng: null,
      extLayer: null,
      extMng: null,
      marker3DContainer: null,
      viewToken: '',
      loadSceneId: domainData.loadSceneId,
      isLayerAdded: false,
      isAddItemActivated: false,
      mainTitle: domainData.mainTitle || '',  // 新增
      // 质量问题数据（动态加载）
      qualityData: domainData.qualityData,
      projectStats: domainData.projectStats || {},
      // 标签坐标列表（动态加载）
      markerLocations: domainData.markerLocations,
      safetyData: domainData.safetyData || {},
      currentTime: '',
      currentDate: '',
      constructionData: domainData.constructionData || {},
      // 模型数据（动态加载）
      loadingModel: domainData.loadingModel,
      
      // 图片文件夹路径
      imageFolder: domainData.imageFolder,
      
      // 对话框状态
      showDialog: false,
      selectedFile: null,
      showSectionDialog: false,
      selectedSection: null,
      
      // 拖拽状态
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dialogStartX: 0,
      dialogStartY: 0,
      dialogWidth: 400,
      dialogHeight: 300,
      
      // 质量图表实例
      qualityChart: null


    }
  },
  mounted() {
    this.updateTime()
    setInterval(this.updateTime, 1000)
    this.initQualityChart()
    this.initSafetyChart()


  },
  beforeDestroy() {
    // 清理资源
    if (this.viewer) {
      this.viewer.destroy()
    }
  },
  methods: {
    // 自动加载并分配图片到markerLocations
    loadImagesToMarkerLocations(name) {
      try {

        // 使用webpack的require.context扫描文件夹
        const imageContexts = {
          '173': require.context('./Sources/173', false, /\.(png|jpg|jpeg)$/i),
          'C62': require.context('./Sources/C62', false, /\.(png|jpg|jpeg)$/i)
        };
        const imagesContext = imageContexts[name];
        
        // 获取所有图片文件
        const imageFiles = imagesContext.keys().map((key) => {
          const fileName = key.replace('./', '')
          const ext = fileName.split('.').pop().toUpperCase()
          return {
            name: fileName,
            format: ext,
            size: this.getFileSize(fileName),
            date: this.getFileDate(),
            path: imagesContext(key)
          }
        })
        
        console.log('扫描到的图片文件:', imageFiles)
        
        // 将图片平均分配到markerLocations
        const locationsCount = this.markerLocations.length
        const filesPerLocation = Math.ceil(imageFiles.length / locationsCount)
        
        imageFiles.forEach((file, index) => {
          const locationIndex = Math.floor(index / filesPerLocation)
          if (locationIndex < locationsCount) {
            this.markerLocations[locationIndex].fileList.push(file)
          }
        })
        
        console.log('图片分配完成:', this.markerLocations)
      } catch (error) {
        console.error('加载图片失败:', error)
      }
    },
    
    // 生成模拟文件大小
    getFileSize(fileName) {
      const sizes = ['1.2MB', '2.5MB', '3.8MB', '4.1MB', '5.6MB', '6.3MB', '7.8MB', '8.2MB']
      return sizes[Math.floor(Math.random() * sizes.length)]
    },
    
    // 生成模拟文件日期
    getFileDate() {
      const startDate = new Date('2024-01-01')
      const endDate = new Date('2024-12-31')
      const randomDate = new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime()))
      return randomDate.toISOString().split('T')[0]
    },
    
    // 预览图片
    previewImage(file) {
      this.previewFile = file
    },
    
    initSafetyChart() {
  const chart = echarts.init(document.getElementById('safety-chart'));
  const safetyChartData = this.safetyData.chart || { data: [] };
  
  const option = {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(5, 30, 40, 0.9)',
      borderColor: 'rgba(0, 200, 180, 0.5)',
      borderWidth: 1,
      textStyle: {
        color: '#fff'
      },
      formatter: '{b}: {c} ({d}%)'
    },
    series: [{
      name: '安全隐患',
      type: 'pie',
      radius: ['35%', '65%'],
      center: ['50%', '45%'],
      avoidLabelOverlap: true,
      viewControl: {
        autoRotate: false,
        distance: 200,
        alpha: 25,
        beta: 15
      },
      label: {
        show: true,
        color: '#fff',
        fontSize: 12,
        formatter: '{b}\n{d}%'
      },
      labelLine: {
        lineStyle: {
          color: 'rgba(0, 200, 180, 0.5)'
        }
      },
      itemStyle: {
        borderColor: 'rgba(0, 200, 180, 0.3)',
        borderWidth: 2
      },
      // 使用动态数据
      data: safetyChartData.data.map(item => ({
        value: item.value,
        name: item.name,
        itemStyle: {
          color: item.color,
          shadowColor: `${item.color}40`  // 添加透明度
        }
      }))
    }]
  };
  
  chart.setOption(option);
  window.addEventListener('resize', () => chart.resize());
},
    initQualityChart() {
      const chart = echarts.init(document.getElementById('quality-chart'))
      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.qualityData.chart.categories,
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 200, 180, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 11
          }
        },
        yAxis: {
          type: 'value',
          max: 15,
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 200, 180, 0.3)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 200, 180, 0.1)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 11
          }
        },
        series: [{
          name: '问题数量',
          type: 'bar',
          data: this.qualityData.chart.values,
          barWidth: '50%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0, 200, 180, 0.8)' },
              { offset: 1, color: 'rgba(0, 150, 130, 0.4)' }
            ]),
            borderRadius: [4, 4, 0, 0],
            borderColor: 'rgba(0, 200, 180, 0.5)',
            borderWidth: 1
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0, 220, 200, 1)' },
                { offset: 1, color: 'rgba(0, 180, 160, 0.6)' }
              ])
            }
          }
        }]
      }
      chart.setOption(option)
      window.addEventListener('resize', () => chart.resize())
    },
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString('zh-CN', { hour12: false })
      this.currentDate = now.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short'
      })
    },
    // 显示进度分色图
    showProgressChart() {
      // 可以在这里实现进度分色图的逻辑
      // 例如：打开弹窗显示进度分色图，或者跳转到其他页面
      alert('进度分色图功能已触发')
      // 可以根据需要扩展这个方法，比如打开一个详细的进度可视化页面
    },
    // 打开文件详情对话框
    openFileDialog(file) {
      this.selectedFile = file
      this.showDialog = true
      // 居中显示对话框
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight
      this.dialogStartX = (screenWidth - this.dialogWidth) / 2
      this.dialogStartY = (screenHeight - this.dialogHeight) / 2
    },
    // 关闭对话框
    closeDialog() {
      this.showDialog = false
      this.selectedFile = null
    },
    // 关闭路段资料对话框
    closeSectionDialog() {
      this.showSectionDialog = false
      this.selectedSection = null
    },
    // 开始拖拽
    startDrag(event) {
      if (event.target.classList.contains('dialog-header')) {
        this.isDragging = true
        this.dragStartX = event.clientX
        this.dragStartY = event.clientY
        event.preventDefault()
      }
    },
    // 拖拽中
    onDrag(event) {
      if (this.isDragging) {
        const deltaX = event.clientX - this.dragStartX
        const deltaY = event.clientY - this.dragStartY
        this.dialogStartX += deltaX
        this.dialogStartY += deltaY
        this.dragStartX = event.clientX
        this.dragStartY = event.clientY
      }
    },
    // 停止拖拽
    stopDrag() {
      this.isDragging = false
    },

    //天地图的SDK
    initSDK() {
      const BimfaceLoaderConfig = new window.BimfaceSDKLoaderConfig()
      BimfaceLoaderConfig.viewToken = this.viewToken
      window.BimfaceSDKLoader.load(BimfaceLoaderConfig, this.onSDKLoadSucceeded, this.onSDKLoadFailed)
    },

    // 资源加载成功的回调函数
    onSDKLoadSucceeded(viewMetaData) {
      const dom4Show = document.getElementById('domId')
      const webAppConfig = new window.Glodon.Bimface.Application.WebApplicationGISConfig()
      webAppConfig.domElement = dom4Show
      webAppConfig.disableMapOcclusion = true;
      this.app = new window.Glodon.Bimface.Application.WebApplicationGIS(webAppConfig)
      this.viewer = this.app.getViewer()
      this.viewer.addScene(this.viewToken)

      // 场景加载的监听事件
      this.viewer.addEventListener(
        window.Glodon.Bimface.Viewer.ViewerGISEvent.SceneAdded,
        this.onSceneAdded
      )

      // 图层加载的监听事件
      this.viewer.addEventListener(
        window.Glodon.Bimface.Viewer.ViewerGISEvent.LayerAdded,
        this.onLayerAdded
      )
    },

    // 场景加载完成
    onSceneAdded() {
      // 获取图层管理器
      this.layerMng = this.viewer.getLayerManager()
      // 获取UI管理器
      this.uiMng = this.app.getUIManager()
      // 获取主工具条
      this.mainToolbar = this.uiMng.getToolbar('MainToolbar')

      // 构造三维标签管理器
      const markerConfig = new window.Glodon.Bimface.Plugins.Marker3D.Marker3DContainerConfig()
      markerConfig.viewer = this.viewer
      this.marker3DContainer = new window.Glodon.Bimface.Plugins.Marker3D.Marker3DContainer(markerConfig)

      // 构造外部构件图层
      this.extLayer = new window.Glodon.Bimface.Layer.ExternalObjectLayer({
        id: 'ext',
        name: 'exename'
      })
      this.viewer.getLayerManager().addLayer(this.extLayer)
      // 获取外部构件图层对应的管理器对象
      this.extMng = this.layerMng.getLayer('ext').getExternalObjectManager()

      // 场景加载完成后自动添加BIM模型
      this.addBIMLayer()
      this.addMarker3D()
      // 场景加载完成后自动添加三维标签

    },

    // 图层加载完成
    onLayerAdded(data) {
      if (data.layerId === 'layer-2517075049457408') {
        const bimLayer = this.layerMng.getLayer('layer-2517075049457408')
        this.viewer.getCamera().zoomToBoundingBox({
          boundingBox: bimLayer.getBoundingBox()
        })
      }
    },

    // 资源加载失败的回调函数
    onSDKLoadFailed(error) {
      console.error('SDK加载失败:', error)
    },

    // 相机视角定位
    setCameraStatus() {
      this.viewer.getCamera().setStatus({
        orientation: { pitch: -1.2425808580399136, yaw: 3.920252926403413, roll: 0 },
        position: { lat: 33.761973270228054, lon: 113.03169694448638, alt: 399.4244951931313 }
      })
    },

    // 添加模型资源
    addBIMLayer() {
      this.loadingModel.forEach((model, index) => {
        if (!model.viewToken) {
            console.warn(`模型 ${model.Id} 缺少 viewToken，跳过`);
            return;
        }
        
        const bimLayer = new window.Glodon.Bimface.Layer.BIMLayer({
            name: model.Name || `BIM模型${index + 1}`,
            id: model.Id ,
            isVisible: model.isVisible !== undefined ? model.isVisible : true,
            viewToken: model.viewToken,
            location: model.location || { lat: 31.1310597, lon: 107.1971763, alt: 1 }
        })
        
        this.layerMng.addLayer(bimLayer)
    })
    },

    // 添加三维标签
    addMarker3D() {
      this.markerLocations.forEach((item, index) => {
        const config = new window.Glodon.Bimface.Plugins.Marker3D.Marker3DConfig()
        config.tooltip = item.name
        // 使用每个坐标对应的图片链接
        config.src = item.imgUrl
        config.worldPosition = item.worldposition,
        // 使用自定义的标签名称
        config.name = item.name
        config.size = 120
        const marker3d = new window.Glodon.Bimface.Plugins.Marker3D.Marker3D(config)
        const that = this
        const currentItem = item  // 捕获当前循环的item
        marker3d.onClick(function () {
          // 使用捕获的当前item
          console.log('点击了标签:', currentItem.name)
          that.selectedSection = currentItem
          that.showSectionDialog = true
        })
        this.marker3DContainer.addItem(marker3d)
      })
      //this.addMarkerBtnText = '标签已添加'
    },

    overrideColor() {
      // 遍历 loadingModel，为每个模型图层执行着色
      this.loadingModel.forEach((model) => {
        const drawingLayerId = model.Id;
        if (!drawingLayerId) {
          console.warn('模型缺少 Id 字段:', model);
          return;
        }
        
        const drawingLayer = this.viewer.getLayerManager().getLayer(drawingLayerId);
        if (!drawingLayer) {
          console.warn(`图层 ${drawingLayerId} 不存在`);
          return;
        }
        
        // 根据图层进行图元着色
        this.markerLocations.forEach(item => {
          drawingLayer.getComponentManager().overrideColor(
            { ids: [item.id] },
            new Glodon.Web.Graphics.Color(item.color, 0.5)
          );
        });
        
        console.log(`图层 ${drawingLayerId} 着色完成`);
      });
      
      this.viewer.render();
      this.addMarker3D();
    }


  },
  created() {
    // 自动加载图片并分配到markerLocations
    console.log("加载图片"+this.suffix)
    this.loadImagesToMarkerLocations(this.suffix);
    
    this.$axios({
      url: this.apiurl +
        "LightModel/LoadSceneId?SceneId=" + this.loadSceneId
    }).then((res) => {
      if (res.status == 200) {
        this.viewToken = res.data;
        const loadModelPromises = [];
        // 使用 forEach 避免闭包陷阱，确保每个回调捕获正确的 index
        this.loadingModel.forEach((model, index) => {
          const promise = this.$axios({
            url: this.apiurl + "LightModel/LoadModels?FileId=" + model.Id
          }).then((res) => {
            if (res.status == 200) {
              // 使用 forEach 的 index，闭包正确捕获
              this.loadingModel[index].viewToken = res.data;
              
            }
          }).catch((err) => {
            console.error(`加载模型 ${index + 1} (ID: ${model.Id}) 失败:`, err);
          });
          loadModelPromises.push(promise);
        });

        // 等待所有模型加载完成后再初始化SDK
        Promise.all(loadModelPromises).then(() => {
          console.log(this.loadingModel)
          this.initSDK();
        });
      }
    }, (err) => {
    });

  }
}
</script>

<style scoped>
@import './shared-styles.css';

/* Road1.vue 特有的样式 */
/* ... 原有样式 ... */


/* 大屏容器 */


/* 物料信息面板样式 */
.material-panel {
  padding: 15px;
}

.material-stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 200, 180, 0.2);
}

.material-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.material-stat .stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #00c8b4;
  font-family: 'Courier New', monospace;
  text-shadow: 0 0 10px rgba(0, 200, 180, 0.5);
}

.material-stat .stat-label {
  font-size: 12px;
  color: rgba(150, 220, 210, 0.7);
}

.progress-rings {
  display: flex;
  justify-content: space-around;
}

.ring-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.ring-container {
  position: relative;
  width: 80px;
  height: 80px;
}

.ring-svg {
  width: 100%;
  height: 100%;
}

.ring-progress {
  transition: stroke-dashoffset 0.5s ease;
}

.ring-progress.orange {
  filter: drop-shadow(0 0 6px rgba(243, 156, 18, 0.6));
}

.ring-progress.green {
  filter: drop-shadow(0 0 6px rgba(0, 200, 180, 0.6));
}

.ring-value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  font-family: 'Courier New', monospace;
}

.ring-label {
  font-size: 11px;
  color: rgba(150, 220, 210, 0.7);
  text-align: center;
}

/* 工程进度面板样式 */
.progress-panel {
  padding: 15px;
  position: relative;
}

/* 进度分色图按钮容器 */
.progress-btn-container {
  position: absolute;
  top: 120px;
  right: 15px;
}

.progress-btn {
  padding: 6px 16px;
  background: rgba(0, 200, 180, 0.2);
  border: 1px solid rgba(0, 200, 180, 0.5);
  border-radius: 4px;
  color: #00c8b4;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.progress-btn:hover {
  background: rgba(0, 200, 180, 0.4);
  box-shadow: 0 0 10px rgba(0, 200, 180, 0.4);
}

/* 图例 */
.legend {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

/* 气泡球 */
.bubble {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
}

.bubble.green {
  background: radial-gradient(circle at 30% 30%, #00ff00, #00c8b4);
  box-shadow: 0 0 10px rgba(0, 255, 0, 0.5);
}

.bubble.yellow {
  background: radial-gradient(circle at 30% 30%, #ffff00, #f39c12);
  box-shadow: 0 0 10px rgba(255, 255, 0, 0.5);
}

.bubble.red {
  background: radial-gradient(circle at 30% 30%, #ff6666, #e74c3c);
  box-shadow: 0 0 10px rgba(231, 76, 60, 0.5);
}

/* 表头 */
.progress-header {
  display: flex;
  padding: 12px 15px;
  background: rgba(0, 200, 180, 0.1);
  border-radius: 6px;
  margin-bottom: 10px;
  margin-right: 180px;
}

.col-title {
  flex: 1;
  font-size: 13px;
  font-weight: bold;
  color: #00c8b4;
  text-align: center;
}

.col-title:first-child {
  flex: 1.5;
  text-align: left;
}

/* 数据行 */
.progress-row {
  display: flex;
  padding: 12px 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  margin-right: 180px;
}

.progress-row:last-child {
  border-bottom: none;
}

.row-label {
  flex: 1.5;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.bubble-cell {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 文件列表样式 */
.file-list {
  height: 520px;
  overflow-y: auto;
}

.file-list::-webkit-scrollbar {
  width: 6px;
}

.file-list::-webkit-scrollbar-track {
  background: rgba(0, 200, 180, 0.1);
}

.file-list::-webkit-scrollbar-thumb {
  background: rgba(0, 200, 180, 0.3);
  border-radius: 3px;
}

.list-header {
  display: flex;
  padding: 10px 15px;
  background: rgba(0, 200, 180, 0.1);
  border-bottom: 1px solid rgba(0, 200, 180, 0.3);
  font-weight: bold;
  color: rgba(150, 220, 210, 0.9);
  font-size: 13px;
}

.list-item {
  display: flex;
  padding: 12px 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  transition: background-color 0.2s;
}

.list-item:hover {
  background: rgba(0, 200, 180, 0.1);
}

.list-item:active {
  background: rgba(0, 200, 180, 0.2);
}

.list-col {
  flex: 1;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.list-col.name-col {
  flex: 2;
}

.list-col.format-col {
  text-align: center;
  color: #00c8b4;
}

/* 简单图片预览 */
.image-preview-simple {
  width: 600px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  overflow: hidden;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.no-image {
  width: 600px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

/* 文件对话框图片预览 */
.image-preview-dialog {
  width: 1200px;
  height: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}

.preview-image-dialog {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.no-image-dialog {
  width: 1200px;
  height: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

/* 对话框样式 */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}

.file-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(5, 30, 40, 0.98);
  border: 1px solid rgba(0, 200, 180, 0.3);
  border-radius: 8px;
  box-shadow: 0 0 30px rgba(0, 200, 180, 0.3);
  z-index: 1001;
  min-width: 300px;
  min-height: 200px;
  overflow: hidden;
}

.section-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(5, 30, 40, 0.98);
  border: 1px solid rgba(0, 200, 180, 0.3);
  border-radius: 8px;
  box-shadow: 0 0 30px rgba(0, 200, 180, 0.3);
  z-index: 1001;
  width: 600px;
  max-height: 70vh;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  background: rgba(0, 200, 180, 0.1);
  border-bottom: 1px solid rgba(0, 200, 180, 0.3);
  cursor: move;
}

.dialog-title {
  font-size: 14px;
  font-weight: bold;
  color: #00c8b4;
}

.dialog-close {
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

.dialog-close:hover {
  background: rgba(231, 76, 60, 0.5);
  color: #fff;
}

.dialog-content {
  padding: 20px;
  min-height: 120px;
}

.file-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-row {
  display: flex;
  gap: 10px;
}

.info-label {
  font-size: 13px;
  color: rgba(150, 220, 210, 0.7);
  white-space: nowrap;
}

.info-value {
  font-size: 13px;
  color: #fff;
}

.dialog-resize-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 15px;
  height: 15px;
  background: rgba(0, 200, 180, 0.3);
  cursor: se-resize;
  border-radius: 0 0 8px 0;
}

.dialog-resize-handle:hover {
  background: rgba(0, 200, 180, 0.5);
}

/* 施工人员面板样式 */
.staff-panel {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 20px 10px;
}

.staff-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.staff-num {
  font-size: 28px;
  font-weight: bold;
  color: #00c8b4;
  font-family: 'Courier New', monospace;
  text-shadow: 0 0 15px rgba(0, 200, 180, 0.6);
}

.staff-label {
  font-size: 12px;
  color: rgba(150, 220, 210, 0.8);
}

.staff-icon {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-top: 10px;
}

.staff-icon.blue {
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.3) 0%, rgba(41, 128, 185, 0.1) 100%);
  box-shadow:
    0 0 20px rgba(52, 152, 219, 0.4),
    inset 0 0 20px rgba(52, 152, 219, 0.2);
  border: 1px solid rgba(52, 152, 219, 0.4);
}

.staff-icon.green {
  background: linear-gradient(135deg, rgba(0, 200, 180, 0.3) 0%, rgba(0, 150, 130, 0.1) 100%);
  box-shadow:
    0 0 20px rgba(0, 200, 180, 0.4),
    inset 0 0 20px rgba(0, 200, 180, 0.2);
  border: 1px solid rgba(0, 200, 180, 0.4);
}

.staff-icon.orange {
  background: linear-gradient(135deg, rgba(243, 156, 18, 0.3) 0%, rgba(230, 126, 34, 0.1) 100%);
  box-shadow:
    0 0 20px rgba(243, 156, 18, 0.4),
    inset 0 0 20px rgba(243, 156, 18, 0.2);
  border: 1px solid rgba(243, 156, 18, 0.4);
}

/* 质量问题统计横条 */
.stats-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 12px 15px;
  background: rgba(0, 200, 180, 0.05);
  border-radius: 6px;
  margin-bottom: 12px;
  border: 1px solid rgba(0, 200, 180, 0.15);
}

.stats-bar .stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stats-bar .stat-item:first-child {
  border-right: 1px solid rgba(0, 200, 180, 0.2);
  padding-right: 20px;
}

.stats-bar .stat-icon {
  font-size: 32px;
  filter: drop-shadow(0 0 8px rgba(0, 200, 180, 0.6));
}

.stats-bar .stat-num {
  font-size: 20px;
  font-weight: bold;
  color: #00c8b4;
  font-family: 'Courier New', monospace;
  text-shadow: 0 0 10px rgba(0, 200, 180, 0.5);
}

.stats-bar .stat-item.highlight .stat-num {
  color: #00ff00;
  text-shadow: 0 0 15px rgba(0, 255, 0, 0.8);
}

.stats-bar .stat-label {
  font-size: 11px;
  color: rgba(150, 220, 210, 0.7);
}

/* 工程概况卡片样式 - 左右布局 */
.project-overview {
  padding: 15px;
  display: flex;
  gap: 20px;
}

/* 左侧统计列 */
.stats-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.stats-column .stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: rgba(0, 200, 180, 0.08);
  border-radius: 6px;
  border-left: 3px solid rgba(0, 200, 180, 0.5);
}

.stats-column .stat-label {
  font-size: 13px;
  color: rgba(150, 220, 210, 0.8);
}

.stats-column .stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #00c8b4;
  text-shadow: 0 0 10px rgba(0, 200, 180, 0.5);
  font-family: 'Courier New', monospace;
}

/* 右侧图片区域 */
.image-section {
  width: 200px;
  height: 150px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(0, 200, 180, 0.3);
  box-shadow: 0 0 15px rgba(0, 200, 180, 0.2);
}

.image-section img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 统计项（通用） */
.stat-item {
  text-align: center;
  padding: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.stat-item:last-child {
  border-bottom: none;
}

.stat-value {
  display: block;
  font-size: 28px;
  font-weight: bold;
  color: #00c8b4;
  text-shadow: 0 0 15px rgba(0, 200, 180, 0.6);
  font-family: 'Courier New', monospace;
}

.stat-label {
  display: block;
  font-size: 12px;
  color: rgba(150, 220, 210, 0.8);
  margin-top: 6px;
  letter-spacing: 1px;
}

/* 环境监测项 */
.env-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.env-item:last-child {
  border-bottom: none;
}

.env-icon {
  font-size: 24px;
}

.env-info {
  display: flex;
  flex-direction: column;
}

.env-value {
  font-size: 18px;
  font-weight: bold;
  color: #00c8b4;
  text-shadow: 0 0 10px rgba(0, 200, 180, 0.5);
}

.env-label {
  font-size: 11px;
  color: rgba(150, 220, 210, 0.7);
  letter-spacing: 1px;
}

/* 告警列表 */
.alarm-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.alarm-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.alarm-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.alarm-dot.warning {
  background: #f39c12;
}

.alarm-dot.danger {
  background: #e74c3c;
}

.alarm-text {
  font-size: 13px;
  color: #fff;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}



/* 图表容器 */
.chart-container {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.5);
  padding: 20px 0;
}

.map-icon {
  font-size: 48px;
}

.chart-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.5);
}

.chart-icon {
  font-size: 48px;
}

/* 响应式设计 */
@media (max-width: 1200px) {

  .left-panel,
  .right-panel {
    width: 250px;
  }

  .header-left .title {
    font-size: 22px;
  }

  .time-display {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .left-panel,
  .right-panel {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .panel-card {
    flex: 1;
    min-width: 200px;
  }

  .header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .header-right {
    text-align: center;
  }
}
</style>